import * as changesets from 'json-diff-ts';

const ignoreFields = ['updatedAt', 'isEditable'];

export const getDiff = (snapshot, prevSnapshot) => {
  const diff = changesets.diff(snapshot, prevSnapshot);

  return diff.filter((row) => !ignoreFields.includes(row.key));
};
